import cart from './cartSlice'

const reducer = cart

export default reducer